import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=2e3764bb&"
import script from "./Dropdown.vue?vue&type=script&lang=js&"
export * from "./Dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3764bb')) {
      api.createRecord('2e3764bb', component.options)
    } else {
      api.reload('2e3764bb', component.options)
    }
    module.hot.accept("./Dropdown.vue?vue&type=template&id=2e3764bb&", function () {
      api.rerender('2e3764bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/Dropdown.vue"
export default component.exports